import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import * as yup from "yup";

import ConditionalTooltip from "../../../ConditionalTooltip";
import DivisionSelector from "../../../DivisionSelector";
import * as constants from "../../../../constants";
import selectCognitoUser from "../../../../store/selectors/getCognitoUser";
import findDivisionRelations from "../../../../utils/findDivisionRelations";

const Divisions = ({ user, admin, disabled, onEdit, onSubmit }) => {
  const cognitoUser = useSelector(selectCognitoUser);
  const serviceProviderId =
    cognitoUser.attributes["custom:service_provider_id"];
  const userDivisions = findDivisionRelations(user.userId);
  const { included } = userDivisions;

  const formik = useFormik({
    initialValues: {
      divisionIds: Object.keys(included)
    },
    validationSchema: yup.object({
      divisionIds: yup.array().of(yup.string().required())
    }),
    onSubmit: (values, actions) => {
      const difference = [
        formik.initialValues.divisionIds.filter(
          divisionId => !values.divisionIds.includes(divisionId)
        ),
        values.divisionIds.filter(
          divisionId => !formik.initialValues.divisionIds.includes(divisionId)
        )
      ];
      const input = [];
      // Queue property updates where properties had a division removed
      for (const divisionId of difference[0]) {
        input.push({
          divisionId,
          relationalId: user.userId,
          operation: "DELETE",
          variant: "USER",
          serviceProviderId
        });
      }
      // Queue property updates where properties had a division added
      for (const divisionId of difference[1]) {
        input.push({
          divisionId,
          relationalId: user.userId,
          operation: "CREATE",
          variant: "USER",
          serviceProviderId
        });
      }
      onSubmit(input, updatedDivisionIds => {
        actions.resetForm({
          values: {
            divisionIds: updatedDivisionIds
          }
        });
      });
    }
  });
  useEffect(() => {
    if (formik.dirty) {
      const resetForm = () => {
        formik.resetForm({
          values: {
            divisionIds: Object.keys(included)
          }
        });
      };
      onEdit(formik.handleSubmit, resetForm);
    }
  }, [formik.dirty]);
  useEffect(() => {
    if (!formik.dirty) {
      formik.resetForm({
        values: {
          divisionIds: Object.keys(included)
        }
      });
    }
  }, [user]);
  const handleSelectionChange = divisionIds => {
    if (admin) {
      formik.setFieldValue("divisionIds", divisionIds);
    }
  };
  const classes = useStyles();
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h5">Divisions</Typography>
        <div className={classes.separator} />
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <Typography color="textSecondary" variant="body2">
          {constants.helpText.propertyDivisionAdd}
        </Typography>
      </Grid>
      <ConditionalTooltip
        title={constants.helpText.adminOnlyEdit}
        visible={!admin && !disabled}
      >
        <Grid item xs={12}>
          <DivisionSelector
            selected={formik.values.divisionIds}
            onSelectionChange={handleSelectionChange}
            isEditable={!disabled}
          />
        </Grid>
      </ConditionalTooltip>
    </Grid>
  );
};

const useStyles = makeStyles(theme => ({
  separator: {
    height: 8
  }
}));

export default Divisions;
